import { X, DeviceMobile, Export, DotsThreeVertical, Plus } from "@phosphor-icons/react";
import { isIOS } from "@/lib/pwa";

export default function InstallPrompt({ open, canInstall, onInstall, onClose }) {
  if (!open) return null;
  const ios = isIOS();

  return (
    <div className="fixed inset-0 z-[75] flex items-end justify-center bg-black/60 sm:items-center" data-testid="install-prompt">
      <div className="w-full max-w-md border-2 border-black bg-white shadow-[8px_8px_0px_rgba(0,0,0,1)]">
        <div className="flex items-center justify-between border-b-2 border-black bg-primary px-4 py-3">
          <h2 className="flex items-center gap-2 font-heading text-base font-black uppercase tracking-tight">
            <DeviceMobile weight="bold" size={20} /> Add to Home Screen
          </h2>
          <button data-testid="install-prompt-close" onClick={onClose} className="grid h-9 w-9 place-items-center border-2 border-black bg-white text-black">
            <X weight="bold" size={18} />
          </button>
        </div>

        <div className="p-4">
          <p className="font-mono2 text-sm font-medium leading-snug text-black/70">
            Put unlostcrew on your home screen so it opens fullscreen like a real app — faster to reach and it keeps the map working when signal drops.
          </p>

          {ios ? (
            <div className="mt-4 flex flex-col gap-2" data-testid="ios-install-steps">
              <div className="flex items-center gap-3 border-2 border-black bg-background p-3">
                <span className="grid h-9 w-9 shrink-0 place-items-center border-2 border-black bg-accent text-white">
                  <Export weight="bold" size={18} />
                </span>
                <p className="font-mono2 text-xs font-medium">
                  <b>1.</b> Tap the <b>Share</b> button at the bottom of Safari (the square with an arrow).
                </p>
              </div>
              <div className="flex items-center gap-3 border-2 border-black bg-background p-3">
                <span className="grid h-9 w-9 shrink-0 place-items-center border-2 border-black bg-accent text-white">
                  <Plus weight="bold" size={18} />
                </span>
                <p className="font-mono2 text-xs font-medium">
                  <b>2.</b> Scroll down and tap <b>“Add to Home Screen”</b>.
                </p>
              </div>
              <div className="flex items-center gap-3 border-2 border-black bg-background p-3">
                <span className="grid h-9 w-9 shrink-0 place-items-center border-2 border-black bg-primary text-black font-heading font-black">✓</span>
                <p className="font-mono2 text-xs font-medium">
                  <b>3.</b> Tap <b>Add</b> — the icon appears on your home screen. Done!
                </p>
              </div>
            </div>
          ) : canInstall ? (
            <button
              data-testid="install-prompt-install"
              onClick={onInstall}
              className="mt-4 flex h-14 w-full items-center justify-center gap-2 border-2 border-black bg-primary font-heading text-base font-bold uppercase shadow-[4px_4px_0px_#18181B] transition-transform duration-150 ease-out active:translate-x-[3px] active:translate-y-[3px] active:shadow-none"
            >
              <DeviceMobile weight="bold" size={20} /> Install the app
            </button>
          ) : (
            <div className="mt-4 flex flex-col gap-2" data-testid="android-install-steps">
              <div className="flex items-center gap-3 border-2 border-black bg-background p-3">
                <span className="grid h-9 w-9 shrink-0 place-items-center border-2 border-black bg-accent text-white">
                  <DotsThreeVertical weight="bold" size={18} />
                </span>
                <p className="font-mono2 text-xs font-medium">
                  <b>1.</b> Open your browser <b>menu</b> (the ⋮ in the top corner).
                </p>
              </div>
              <div className="flex items-center gap-3 border-2 border-black bg-background p-3">
                <span className="grid h-9 w-9 shrink-0 place-items-center border-2 border-black bg-primary text-black">
                  <Plus weight="bold" size={18} />
                </span>
                <p className="font-mono2 text-xs font-medium">
                  <b>2.</b> Tap <b>“Add to Home screen”</b> (or “Install app”), then confirm.
                </p>
              </div>
            </div>
          )}

          <button
            data-testid="install-prompt-later"
            onClick={onClose}
            className="mt-3 h-11 w-full border-2 border-black bg-white font-mono2 text-xs font-bold uppercase text-black/60 shadow-[3px_3px_0px_rgba(0,0,0,1)] active:translate-x-[3px] active:translate-y-[3px] active:shadow-none"
          >
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
}
